<template>
  <div class="d-flex flex-column flex-column-fluid mb-20">
    <div class="toolbar" id="kt_toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
             data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
             class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{$t("navigation.setting")}}</h1>
          <span class="h-20px border-gray-300 border-start mx-4"></span>
          <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          </ul>
        </div>
      </div>
    </div>

    <div id="kt_app_content" class="app-content  flex-column-fluid ">
      <div id="kt_app_content_container" class="app-container  container-fluid" style="margin-top: 30px!important;">
        <div class="accordion accordion-icon-toggle" id="kt_accordion_2">
            <div  v-if="$can(abilities.VIEW_GENERAL_SETTINGS)" class="mb-5">
                <div class="accordion-header py-3 d-flex" data-bs-toggle="collapse" data-bs-target="#kt_accordion_2_item_1">
                    <span class="accordion-icon">
                        <i class="fas fa-arrow-right fs-4"><span class="path1"></span><span class="path2"></span></i>
                    </span>
                    <h1 class="fs-4 fw-semibold mb-0 ms-4 w-60px text-uppercase">{{$t('setting.general')}}</h1>
                    <span class="haveBorder flex-grow-1 ms-3"></span>
                </div>
                <div id="kt_accordion_2_item_1" class="fs-6 collapse ps-10 show" data-bs-parent="#kt_accordion_2">
                  <div class="row gy-5 g-xl-10 pt-5">
                    <setting-product-index v-if="$can(abilities.COMPANY_SETTING)"></setting-product-index>
                    <setting-multi-society-index v-if="$can(abilities.MULTI_COMPANY_SETTING)"></setting-multi-society-index>
                    <setting-user-index v-if="$can(abilities.USER_SETTING)"></setting-user-index>
                    <setting-system-index v-if="$can(abilities.SYSTEM_SETTING)" ></setting-system-index>
                  </div>
                </div>
            </div>
            <div class="mb-5" v-if="$canAccess(crmModule) && $can(abilities.VIEW_CRM_SETTINGS)" >
                <div class="accordion-header py-3 d-flex collapsed" data-bs-toggle="collapse" data-bs-target="#kt_accordion_2_item_2">
                    <span class="accordion-icon">
                        <i class="fas fa-arrow-right fs-4"><span class="path1"></span><span class="path2"></span></i>
                    </span>
                    <h1 class="fs-4 fw-semibold mb-0 ms-4 w-60px text-uppercase">CRM</h1>
                    <span class="haveBorder flex-grow-1 ms-3"></span>
                </div>
                <div  id="kt_accordion_2_item_2" class="collapse fs-6 ps-10" data-bs-parent="#kt_accordion_2">
                  <div class="row gy-5 g-xl-10 pt-5">
                    <SettingPipeline v-if="$can(abilities.VIEW_PIPELINE_SETTINGS)" ></SettingPipeline>
                    <SettingAppointmentType v-if="$can(abilities.VIEW_APPOINTMENT_SETTINGS)" ></SettingAppointmentType>
                  </div>
                </div>
            </div>
            <div class="mb-5" v-if="$canAccess(financeModule) && $can(abilities.VIEW_FINANCE_SETTINGS)">
              <div class="accordion-header py-3 d-flex collapsed" data-bs-toggle="collapse" data-bs-target="#kt_accordion_2_item_3">
                      <span class="accordion-icon">
                          <i class="fas fa-arrow-right fs-4"><span class="path1"></span><span class="path2"></span></i>
                      </span>
                <h1 class="fs-4 fw-semibold mb-0 ms-4 w-60px text-uppercase">Finance</h1>
                <span class="haveBorder flex-grow-1 ms-3"></span>
              </div>
              <div  id="kt_accordion_2_item_3" class="collapse fs-6 ps-10" data-bs-parent="#kt_accordion_2">
                <div class="row gy-5 g-xl-10 pt-5">
                  <setting-finance v-if="$can(abilities.VIEW_EXPENSE_SETTINGS)" />
                </div>
              </div>
            </div>
            <div class="mb-5" v-if="$canAccess(rhModule) && $can(abilities.VIEW_RH_SETTINGS)">
              <div class="accordion-header py-3 d-flex collapsed" data-bs-toggle="collapse" data-bs-target="#kt_accordion_2_item_4">
                  <span class="accordion-icon">
                      <i class="fas fa-arrow-right fs-4"><span class="path1"></span><span class="path2"></span></i>
                  </span>
                  <h1 class="fs-4 fw-semibold mb-0 ms-4 w-60px text-uppercase">{{$t("menu.rh.title")}}</h1>
                  <span class="haveBorder flex-grow-1 ms-3"></span>
              </div>
              <div  id="kt_accordion_2_item_4" class="collapse fs-6 ps-10" data-bs-parent="#kt_accordion_2">
                <div class="row gy-5 g-xl-10 pt-5">
                  <SettingPayslips v-if="$can(abilities.VIEW_PAYSLIP_SETTINGS)"/>
                  <SettingAbsence v-if="$can(abilities.VIEW_PAYSLIP_SETTINGS)"/>
                </div>
              </div>
            </div>
            <div class="mb-5"  v-if="$canAccess(projectModule) && $can(abilities.VIEW_PROJECT_SETTINGS)">
              <div class="accordion-header py-3 d-flex collapsed" data-bs-toggle="collapse" data-bs-target="#kt_accordion_2_item_5">
                  <span class="accordion-icon">
                      <i class="fas fa-arrow-right fs-4"><span class="path1"></span><span class="path2"></span></i>
                  </span>
                  <h1 class="fs-4 fw-semibold mb-0 ms-4 w-60px text-uppercase">{{$t("menu.projects.title")}}</h1>
                  <span class="haveBorder flex-grow-1 ms-3"></span>
              </div>
              <div  id="kt_accordion_2_item_5" class="collapse fs-6 ps-10" data-bs-parent="#kt_accordion_2">
                <div class="row gy-5 g-xl-10 pt-5">
                  <SettingProject/>
                </div>
              </div>
            </div>
            <div class="mb-5"  v-if="$can(abilities.VIEW_EVENT_SETTINGS)">
              <div class="accordion-header py-3 d-flex collapsed" data-bs-toggle="collapse" data-bs-target="#kt_accordion_2_item_6">
                  <span class="accordion-icon">
                      <i class="fas fa-arrow-right fs-4"><span class="path1"></span><span class="path2"></span></i>
                  </span>
                  <h1 class="fs-4 fw-semibold mb-0 ms-4 w-60px text-uppercase">{{$t("menu.events.title")}}</h1>
                  <span class="haveBorder flex-grow-1 ms-3"></span>
              </div>
              <div  id="kt_accordion_2_item_6" class="collapse fs-6 ps-10" data-bs-parent="#kt_accordion_2">
                <div class="row gy-5 g-xl-10 pt-5">
                  <SettingEvent/>
                </div>
              </div>
            </div>
          <div class="mb-5"  v-if="$canAccess(qvctSurveyModule)">
            <div class="accordion-header py-3 d-flex collapsed" data-bs-toggle="collapse" data-bs-target="#kt_accordion_2_item_7">
                  <span class="accordion-icon">
                      <i class="fas fa-arrow-right fs-4"><span class="path1"></span><span class="path2"></span></i>
                  </span>
              <h1 class="fs-4 fw-semibold mb-0 ms-4 w-60px text-uppercase">{{$t("menu.qvct_survey.title")}}</h1>
              <span class="haveBorder flex-grow-1 ms-3"></span>
            </div>
            <div  id="kt_accordion_2_item_7" class="collapse fs-6 ps-10" data-bs-parent="#kt_accordion_2">
              <div class="row gy-5 g-xl-10 pt-5">
                <SettingQvctSurvey/>
              </div>
            </div>
          </div>
            <div class="mb-5"  v-if="$canAccess(moduleAbilities.ACCESS)">
              <div class="accordion-header py-3 d-flex collapsed" data-bs-toggle="collapse" data-bs-target="#kt_accordion_2_item_7">
                  <span class="accordion-icon">
                      <i class="fas fa-arrow-right fs-4"><span class="path1"></span><span class="path2"></span></i>
                  </span>
                  <h1 class="fs-4 fw-semibold mb-0 ms-4 w-60px text-uppercase">{{$t("menu.access.title")}}</h1>
                  <span class="haveBorder flex-grow-1 ms-3"></span>
              </div>
              <div  id="kt_accordion_2_item_7" class="collapse fs-6 ps-10" data-bs-parent="#kt_accordion_2">
                <div class="row gy-5 g-xl-10 pt-5">
                  <SettingAccess/>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import SettingProductIndex from "@/views/Settings/SettingProductIndex";
import SettingUserIndex from "@/views/Settings/SettingUserIndex";
import SettingSystemIndex from "@/views/Settings/SettingSystemIndex.vue";
import SettingFinance from '@/views/Settings/SettingFinance.vue';
import SettingAppointmentType from '@/Modules/CRM/views/Setting/SettingAppointmentType.vue';
import SettingPipeline from '@/Modules/CRM/views/Setting/SettingPipeline.vue';
import moduleAbilities from "@/composables/moduleAbilities";
import abilities from '@/composables/abilities';
import {ref} from "vue";
import SettingPayslips from "@/Modules/RH/views/Setting/SettingPayslips.vue";
import SettingMultiSocietyIndex from "@/views/Settings/SettingMultiSocietyIndex";
import SettingProject from "@/Modules/Projects/views/Setting/SettingProject.vue";
import SettingAbsence from "@/Modules/RH/views/Setting/SettingAbsence.vue";
import SettingEvent from "@/Modules/Events/views/Setting/SettingEvent.vue"
import SettingAccess from "@/Modules/Access/views/Setting/SettingAccess.vue"
import SettingQvctSurvey from "@/Modules/Qvct/views/Settings/SettingQvctSurvey.vue"

const crmModule = ref([
  moduleAbilities.CRM_INVOICE,
  moduleAbilities.CRM_INVOICE,
  moduleAbilities.CRM_PIPELINE,
  moduleAbilities.CRM_APPOINTMENT
])

const financeModule = ref([
  moduleAbilities.FINANCE_ACCOUNT,
  moduleAbilities.FINANCE_EXPENSE
])

const rhModule = ref([
  moduleAbilities.RH_ABSENCE,
  moduleAbilities.RH_CONTRACT,
  moduleAbilities.RH_PAYSLIP
])

const projectModule = ref([
  moduleAbilities.PROJECT,
  moduleAbilities.NOTARIAL_REPERTORY,
])

const qvctSurveyModule = ref([
  moduleAbilities.QVCT_SURVEY
])

</script>
<style scoped>
.haveBorder {
    border-top: 1px solid rgba(204, 207, 211, 1);
    margin-top: 10px;
    flex-grow: 1;
}

.accordion-header {
    position: relative;
    padding-right: 10px;
}

.accordion.accordion-icon-toggle .collapsed .accordion-icon .svg-icon, .accordion.accordion-icon-toggle .collapsed .accordion-icon i {
    color: #000 !important;
}
</style>
